const registry = new Map<string, string>();

export function registerRoutePermission(
  path: string,
  permission: string,
): void {
  registry.set(path, permission);
}

export function permissionForRoute(pathname: string): string | null {
  let best: { path: string; permission: string } | null = null;
  for (const [path, permission] of registry) {
    const onRoute = pathname === path || pathname.startsWith(path + "/");
    if (onRoute && (best === null || path.length > best.path.length)) {
      best = { path, permission };
    }
  }
  return best?.permission ?? null;
}
